<div class="WeatherMain" *ngIf="WeatherData?.forecast?.forecastday.length>0">
    <div class="weatherlabel center">Weather Forecast</div>
    <div class="weathersection">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-5">
                <div class="weatherimage center">
                    <i class="fa-thin weathericon" class={{WeatherIconData}}></i>
                    <!-- <fa-icon class="fa-thin weathericon help" [icon]="['fat',WeatherIconData]"></fa-icon> -->

                </div>
                <div class="currenttemp center">
                    {{WeatherData?.forecast?.forecastday[0]?.day.condition?.text}}
                    <!-- {{WeatherData?.forecast?.forecastday[0]?.temp_f}}&deg; -->
                </div>
            </div>
            <div class="col-5">

                <div class="highlow center">
                    Low {{WeatherData?.forecast?.forecastday[0]?.day?.mintemp_f}}&deg;
                </div>
                <div class="highlow center">
                    High {{WeatherData?.forecast?.forecastday[0]?.day?.maxtemp_f}}&deg;
                </div>
                <div class="highlow center">
                    Wind {{WeatherData?.forecast?.forecastday[0]?.day?.maxwind_mph}} mph
                </div>
                <!-- <div class="highlow center">
            Rain chance {{WeatherData?.forecast?.forecastday[0]?.day?.daily_will_it_rain}}
        </div> -->
                <div class="highlow center">
                    Chance of Rain {{WeatherData?.forecast?.forecastday[0]?.day?.daily_chance_of_rain}}%
                </div>

            </div>
            <div class="col-1"></div>
        </div>
    </div>
    <div class="row"></div>

</div>